module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-800.01e4d33.ttf";